import gapiService from '@/services/gapi.service';
import microsoftService from '@/services/microsoft.service';
import { useQueryClient } from '@tanstack/react-query';

export default function useSyncCalendar() {
	const client = useQueryClient();

	function handleSyncMicrosoft() {
		return microsoftService.syncCalendars();
	}

	function handleSyncGoogle() {
		return gapiService.syncCalendars().finally(() => {
			client.invalidateQueries();
		});
	}

	return {
		handleSyncGoogle,
		handleSyncMicrosoft,
	};
}
